import crud from "./_crud";

const actions = crud('starmilk_route', 'la ruta', 'las rutas');

export default actions